import { nativeBackFormState } from './nativeBackForms';

export const GUARDED_NAVIGATION_EVENT = 'teamplay:guarded-navigation';
export type GuardedNavigation = { action: () => void; scope: Element; protectDirty: boolean };

const approvals = new WeakMap<Element, object>();
/** Zag handles Escape in a microtask. Approve one close of this exact scope, for one turn. */
export const runApprovedNavigation = (action: () => void, scope: Element = document.body) => {
  const token = {};
  approvals.set(scope, token);
  setTimeout(() => {
    if (approvals.get(scope) === token) approvals.delete(scope);
  }, 0);
  action();
};

/** Screen controls and Android Back use the same confirmation host as iOS Back. */
export const requestGuardedNavigation = (
  action: () => void,
  scope: Element = document.body,
  protectDirty = true
) => {
  if (approvals.has(scope)) {
    approvals.delete(scope);
    if (scope.isConnected && nativeBackFormState(scope) !== 'busy') action();
    return;
  }
  const event = new CustomEvent<GuardedNavigation>(GUARDED_NAVIGATION_EVENT, {
    cancelable: true,
    detail: { action, scope, protectDirty },
  });
  if (window.dispatchEvent(event) && nativeBackFormState(scope) === 'ready') action();
};
